import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, Navigate } from 'react-router-dom';
import { api } from '../app/Api/ApiSlice';
import { updateProfile } from '../app/slices/authSlice'
import { selectCurrentUser } from '../app/selectors/authSelectors';

const ProtectRoutes = () => {

    const dispatch = useDispatch()

    const user = useSelector(selectCurrentUser);
    // console.log(user)

    useEffect(() => {
        if (!user?.profilePic) return;

        // If it's already a URL (or data URI), don't re-fetch.
        const pic = user.profilePic;
        if (typeof pic === "string" && (pic.startsWith("http://") || pic.startsWith("https://") || pic.startsWith("data:"))) {
            return;
        }

        let cancelled = false;

        const getAvatar = async () => {
            try {
                const response = await api.post("/url", { file: pic });
                const url = response?.data?.url;
                if (!cancelled && url) dispatch(updateProfile(url));
            } catch (error) {
                if (!cancelled) console.error("Failed to fetch avatar:", error);
            }
        };

        getAvatar();
        return () => {
            cancelled = true;
        };
    }, [dispatch, user?.profilePic]);

    return user ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectRoutes;